"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryDataByDepartureAtRangeConsideringTimezone = void 0;
const date_fns_1 = require("date-fns");
const transformBookingToUTC_1 = require("../transformers/transformBookingToUTC");
/**
 * Query data by departure at range considering timezone.
 * @param options Options.
 * @returns Data with departure within the provided range with respect to the timezone.
 */
async function queryDataByDepartureAtRangeConsideringTimezone(options) {
    const { departureAtFromInLocalTime, departureAtToInLocalTime, dataRangeQuery, timezoneQuery } = options;
    // add +14 and -12 hours to cover the whole range of timezones, i.e. UTC+14 to UTC-12
    const departureAtRangeFrom = (0, date_fns_1.subHours)(departureAtFromInLocalTime, 12);
    const departureAtRangeTo = (0, date_fns_1.addHours)(departureAtToInLocalTime, 14);
    const dataWithDepartureInRange = await dataRangeQuery(departureAtRangeFrom, departureAtRangeTo);
    const dataWithDepartureInRangeWithTimezone = await Promise.all(dataWithDepartureInRange.map(async (data) => {
        const timezone = await timezoneQuery(data);
        return {
            data,
            timezone,
        };
    }));
    const dataFilteredByTimezones = dataWithDepartureInRangeWithTimezone
        .filter((pair) => pair.timezone !== undefined) // filter out the orders with missing location
        .filter((pair) => {
        const { data, timezone } = pair;
        // filter by the departure time in order's origin timezone
        const departureAtInUTC = (0, transformBookingToUTC_1.transformBookingToUTC)(data.departureAt, timezone);
        return (departureAtInUTC.getTime() >= departureAtFromInLocalTime.getTime() &&
            departureAtInUTC.getTime() <= departureAtToInLocalTime.getTime());
    })
        .map(({ data }) => data);
    return dataFilteredByTimezones;
}
exports.queryDataByDepartureAtRangeConsideringTimezone = queryDataByDepartureAtRangeConsideringTimezone;
//# sourceMappingURL=queryDataByDepartureAtRangeConsideringTimezone.js.map